/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Col_WhenInputs */

const en_audit_col_when = /** @type {(inputs: Audit_Col_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When`)
};

const pt_br2_audit_col_when = /** @type {(inputs: Audit_Col_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando`)
};

/**
* | output |
* | --- |
* | "When" |
*
* @param {Audit_Col_WhenInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const audit_col_when = /** @type {((inputs?: Audit_Col_WhenInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Col_WhenInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_col_when(inputs)
	return pt_br2_audit_col_when(inputs)
});